import { EBrandButtonTypes } from 'Libraries/buttons.library';
import { useEffect, useState } from 'react';
import { PATHS } from 'Libraries/routes.library';
import Link from 'Components/shared/Link/Link';
import { useDispatch, useSelector } from 'react-redux';
import {
  IApplicationState,
  OVERLAY_ALL_CLOSE,
  OVERLAY_LOGIN_SHOW,
  OVERLAY_PAYNPLAY_LOGIN_SHOW,
  OVERLAY_SEARCH_SHOW,
} from '@spinwise/spinwise-core';
import { t } from 'i18next';
import { useRouter } from 'next/router';
import { useRegType } from 'Hooks/useRegType';
import { useStrapiTitles } from 'Hooks/strapi-titles';
import { ETitles, RegTypes } from 'Types/globals';
import { GuestHeader } from '@spinwise/react-component-library/GuestHeader';
import { IconGames } from '@spinwise/react-component-library/IconGames';
import { IconSports } from '@spinwise/react-component-library/IconSports';
import { IconLoyalty } from '@spinwise/react-component-library/IconLoyalty';
import { IconSearch } from '@spinwise/react-component-library/IconSearch';
import useShowAuthButtons from 'Hooks/useShowAuthButtons';

interface GuestHeaderProps {
  headerBehaviorClass?: string;
  scrolledType?: EBrandButtonTypes;
  children?: React.ReactNode;
  player_type?: any;
}

// Renders logged in user header
const GuestHeaderFront = ({ player_type }: GuestHeaderProps) => {
  const [navBarActive, setNavBarActive] = useState(true);
  const [isSearchActive, setisSearchActive] = useState(false);

  const showLoginButton = useShowAuthButtons();

  const handleScroll = e => {
    if (document.scrollingElement.scrollTop >= 30) {
      setNavBarActive(true);
    } else {
      setNavBarActive(false);
    }
  };

  useEffect(() => {
    if (router.pathname == '/') {
      window.addEventListener('scroll', handleScroll);
      setNavBarActive(false);
    }

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const overlayReducer = useSelector((state: IApplicationState) => state.overlayReducer);
  const geo = useSelector((state: IApplicationState) => state.globalReducer.geo);

  useEffect(() => {
    if (overlayReducer.headerSearch.show == true) {
      setisSearchActive(true);
    } else {
      setisSearchActive(false);
    }
  }, [overlayReducer.headerSearch.show]);

  const router = useRouter();

  const checkIsActive = (path): boolean => {
    if (router.pathname == path) return true;
    return false;
  };

  const dispatch = useDispatch();

  const isRegType = useRegType();

  const [strapiLoginBtn, strapiRegisterBtn] = useStrapiTitles([ETitles.LOGIN_BTN_TEXT, ETitles.REGISTER_BTN_TEXT]);

  return (
    <>
      <GuestHeader
        isActive={navBarActive}
        logo={{
          imageDefault: '/images/logo-full-white.svg',
          imageOnScroll: '/images/logo-full.svg',
          link: {
            linkElement: Link,
            href: PATHS.HOME,
            ariaLabel: 'To home page',
            query: router?.query,
          },
        }}
        menu={[
          ...(isSearchActive == false
            ? [
                {
                  icon: IconGames,
                  text: t(`header.games.link`),
                  link: {
                    href: PATHS.GAMES,
                    linkElement: Link,
                    ariaLabel: t('header.games.link'),
                    query: router?.query,
                  },
                  isActive: checkIsActive(PATHS.GAMES),
                },
                ...(geo?.sportsbook
                  ? [
                      {
                        icon: IconSports,
                        text: t('header.sports.link'),
                        link: {
                          href: PATHS.SPORTS,
                          linkElement: Link,
                          ariaLabel: t('header.sports.link'),
                          query: router?.query,
                        },
                        isActive: checkIsActive(PATHS.SPORTS),
                      },
                    ]
                  : []),
                {
                  icon: IconLoyalty,
                  text: t('header.promotions.link'),
                  link: {
                    href: PATHS.PROMOTIONS,
                    linkElement: Link,
                    ariaLabel: t('header.promotions.link'),
                    query: router?.query,
                  },
                  isActive: checkIsActive(PATHS.PROMOTIONS),
                },
                {
                  icon: IconSearch,
                  text:
                    overlayReducer.headerSearch.searchText == '' || overlayReducer.headerSearch.searchText == null
                      ? t('header.search.placeholder')
                      : overlayReducer.headerSearch.searchText,
                  onClickEvent: () => {
                    dispatch({
                      type: OVERLAY_SEARCH_SHOW,
                      data: true,
                    });
                  },
                  isActive: false,
                },
              ]
            : []),
        ]}
        buttonLogin={{
          isVisible: showLoginButton,
          text: strapiLoginBtn,
          onClickEvent: () => {
            dispatch({
              type: OVERLAY_ALL_CLOSE,
              data: true,
            });

            if (isRegType([RegTypes.PAYPLAY_T, RegTypes.PAYPLAY_Z])) {
              dispatch({
                type: OVERLAY_PAYNPLAY_LOGIN_SHOW,
                data: true,
              });
              return;
            }
            //regType =  email or deposit
            dispatch({
              type: OVERLAY_LOGIN_SHOW,
              data: true,
            });
          },
        }}
        buttonRegister={{
          isVisible: true,
          text: strapiRegisterBtn,
          link: {
            linkElement: Link,
            href: PATHS.REGISTER,
            ariaLabel: strapiRegisterBtn,
            query: router?.query,
          },
        }}
      />
    </>
  );
};

export default GuestHeaderFront;
